module.exports = __webpack_public_path__ + "static/media/60--backyard.02433756.jpeg";